export default __webpack_public_path__ + "static/media/294.3e2940e8.png";